const LIV_SCROLL_TRIGGER_CLASS = 'liv-scroll-trigger';
const LIV_SCROLL_OFFSCREEN_CLASS = 'liv-scroll--offscreen';
const LIV_SCROLL_ZOOM_CLASS = 'liv-zoom-in';
const LIV_SCROLL_CANCEL_CLASS = 'liv-scroll--cancel';

// Мягкая анимация появления
function onLivIntersection(entries, observer) {
  entries.forEach((entry, index) => {
    const el = entry.target;

    if (entry.isIntersecting) {
      if (el.classList.contains(LIV_SCROLL_OFFSCREEN_CLASS)) {
        el.classList.remove(LIV_SCROLL_OFFSCREEN_CLASS);

        if (el.hasAttribute('data-cascade')) {
          el.style.setProperty('--liv-animation-order', index);
        }
      }

      observer.unobserve(el);
    } else {
      el.classList.add(LIV_SCROLL_OFFSCREEN_CLASS);
      el.classList.remove(LIV_SCROLL_CANCEL_CLASS);
    }
  });
}

// Инициализация триггеров появления
function initLivScrollTriggers(root = document, isDesignMode = false) {
  const elements = Array.from(root.getElementsByClassName(LIV_SCROLL_TRIGGER_CLASS));
  if (elements.length === 0) return;

  if (isDesignMode) {
    elements.forEach((el) => el.classList.add('liv-scroll--design-mode'));
    return;
  }

  const observer = new IntersectionObserver(onLivIntersection, {
    rootMargin: '0px 0px -60px 0px', // слегка увеличен эффект
  });

  elements.forEach((el) => observer.observe(el));
}

// Zoom-in эффект при скролле
function initLivZoomEffect() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const elements = Array.from(document.getElementsByClassName(LIV_SCROLL_ZOOM_CLASS));
  if (elements.length === 0) return;

  const zoomScale = 0.25 / 100;

  elements.forEach((el) => {
    let isVisible = false;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => isVisible = entry.isIntersecting);
    });

    observer.observe(el);
    el.style.setProperty('--zoom-in-ratio', 1 + zoomScale * getSeenPercentage(el));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!isVisible) return;
        el.style.setProperty('--zoom-in-ratio', 1 + zoomScale * getSeenPercentage(el));
      }),
      { passive: true }
    );
  });
}

// Подсчёт видимой части элемента
function getSeenPercentage(el) {
  const viewHeight = window.innerHeight;
  const scrollTop = window.scrollY;
  const elTop = el.getBoundingClientRect().top + scrollTop;
  const elHeight = el.offsetHeight;

  if (elTop > scrollTop + viewHeight) return 0;
  if (elTop + elHeight < scrollTop) return 100;

  const distance = scrollTop + viewHeight - elTop;
  const percentage = distance / ((viewHeight + elHeight) / 100);
  return Math.round(percentage);
}

// Запуск при загрузке
window.addEventListener('DOMContentLoaded', () => {
  initLivScrollTriggers();
  initLivZoomEffect();
});

// Поддержка Shopify редактора
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) =>
    initLivScrollTriggers(event.target, true)
  );
  document.addEventListener('shopify:section:reorder', () =>
    initLivScrollTriggers(document, true)
  );
}